export default "__VITE_ASSET__DfDUqsZr__"